export default __webpack_public_path__ + "static/media/_ic_euro_act.545e7a9a.svg";